import { isStaffPath } from '../shared/staff-workspaces';
import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { startAnalytics } from './analytics';
import { inCard, keepLinksOutOfCard, withHerBehind } from './card';
import { frontDoor } from './frontDoor';
import './styles.css';
import '@fontsource-variable/inter';
import './patient-theme.css';

// Each workspace downloads its own app. Opening Admin or Clinic must not wait
// for the patient chat, scan and programs to download and execute first.
const App = lazy(() => import('./App').then(m => ({ default: m.App })));
const CockpitApp = lazy(() => import('./cockpit/CockpitApp'));
const cockpit = isStaffPath(window.location.pathname);

// The bare address opens Home (src/frontDoor.ts).
const door = frontDoor(window.location.pathname, window.location.search, window.location.hash);
if (door) window.location.replace(door);

// A card's page is counted once, as Home, so it starts no analytics of its own.
if (!door && !cockpit && !inCard()) void startAnalytics();
// A page inside one of Home's cards (src/card.ts).
if (inCard()) keepLinksOutOfCard();
// The chat with her behind it: the page is see-through, so Home's picture of her shows (src/styles.css).
if (withHerBehind()) document.documentElement.dataset.her = '1';

if (!door) createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* A quiet outline while the chosen app loads. */}
    <Suspense fallback={<div aria-busy="true" style={{ padding: 24, display: 'grid', gap: 14, maxWidth: 900, margin: '0 auto', opacity: 0.5 }}>{[40, 16, 220, 220].map((h, i) => <div key={i} style={{ height: h, borderRadius: 12, background: 'currentColor', opacity: 0.08 }} />)}</div>}>
      {cockpit ? <CockpitApp /> : <App />}
    </Suspense>
  </StrictMode>,
);
